import { cleanEntityItemDetails, NormalizedEntityItem } from '@/lib/edlink-utils';
import { Fragment } from 'react';

interface SummaryItemListProps {
  items: NormalizedEntityItem[];
}

export function SummaryItemList({ items }: SummaryItemListProps) {
  return (
    <ul className="grid grid-cols-2 gap-x-4 gap-y-1 ml-4 pb-2 text-sm text-muted-foreground">
      {items.map((item, i) => (
        <li key={i} className="list-disc list-inside">
          <span title={item.label}>{item.label}</span>
          {item.details && (
            <dl className="ml-5 mt-1 grid grid-cols-[auto_1fr] gap-x-1 text-xs text-muted-foreground/70">
              {Object.entries(cleanEntityItemDetails(item.details)).map(([itemKey, itemValue]) => (
                <Fragment key={`${i}-${itemKey}`}>
                  <dt className="font-medium">{`${itemKey.charAt(0).toUpperCase()}${itemKey.slice(1)}:`}</dt>
                  <dd className="truncate" title={itemValue}>
                    {itemValue}
                  </dd>
                </Fragment>
              ))}
            </dl>
          )}
        </li>
      ))}
    </ul>
  );
}
